import { render } from "./Credits.vue?vue&type=template&id=35b489d1&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"

import "./Credits.vue?vue&type=style&index=0&id=35b489d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b489d1"]])

export default __exports__